export const CLOUDFLARE_CLIENT_ACCESS_URL = `https://www.cloudflare.com/cdn-cgi/trace`
